import { createContext, useContext } from 'react';

/**
 * True while the run components are rendering a read-only procedure snippet
 * (e.g. previewing an implementation function) rather than an actual procedure run.
 *
 * The run components write back to the containers they render — step status and
 * parameter values are persisted. A snippet points at authoring data that later gets
 * copied into generated procedures, so anything that writes must be suppressed.
 */
const SnippetPreviewContext = createContext(false);

export function SnippetPreviewProvider({ children }: { children: React.ReactNode }) {
  return (
    <SnippetPreviewContext.Provider value={true}>
      {children}
    </SnippetPreviewContext.Provider>
  );
}

export function useIsSnippetPreview() {
  return useContext(SnippetPreviewContext);
}
